/**
 * projectContainerEventTypes
 *
 * Shared TypeScript types and enums for all project container realtime
 * events (container intake, folders, and list-level container events).
 *
 * These types are consumed by normalizers and reducers in:
 * - projectContainerEventNormalizers.ts
 * - projectContainerListEventState.ts
 * - projectContainerOverviewEventToState.ts
 * - projectContainerSectionsIntakeEventToState.ts
 * - projectContainerSectionsFolderEventToState.ts
 */
import type { ProjectIntakeInboxModel } from 'src/features/companyProjects/projectIntake/inbox/types';

// ----- Container intake events -----

export enum ProjectSectionIntakeEventType {
  IntakeAdded = 0,
  IntakeRemoved = 1,
  IntakeMoved = 2,
  IntakeUpdated = 3
}

export type ProjectContainerEventType = ProjectSectionIntakeEventType;

export interface ProjectContainerEvent {
  containerId: number;
  intakeId: number;
  type: ProjectContainerEventType;
  fromFolderId?: number;
  toFolderId?: number;
  data?: ProjectIntakeInboxModel;
}

// ----- Folder events -----

export enum ProjectFolderEventType {
  FolderCreated = 0,
  FolderDeleted = 1,
  FolderRenamed = 2
}

export interface ProjectFolderEvent {
  containerId: number;
  folderId: number;
  type: ProjectFolderEventType;
  name?: string;
}

// ----- List-level container events (assigned containers, tables) -----

export type ProjectContainerListEventType = 'Created' | 'Updated';

export type ProjectContainerListEventDto = {
  containerId: number;
  companyId: number;
  name: string;
  assignedToUserId?: string | null;
  additionalAssignedToUserIds?: string[];
  stage: string;
  type: ProjectContainerListEventType;
};

export type ProjectContainerListEvent = ProjectContainerListEventDto;

// ----- Project hotel events -----

export enum ProjectHotelEventType {
  HotelAdded = 0,
  HotelUpdated = 1,
  EmailIntakeCreated = 2
}

export interface ProjectHotelRealtimeEvent {
  containerId: number;
  type: ProjectHotelEventType;
  projectHotelId?: number;
  hotelRateId?: number;
  projectIntakeId?: number;
}

// ----- Project assessment events -----

export interface ProjectAssessmentRealtimeEvent {
  containerId: number;
}
